import styles from "./Sidebar.module.scss";
import logo from "assets/images/swan.svg";
import CreditCard from "assets/icons/creditCard";
import LogOut from "assets/icons/logOut";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ROUTES } from "lib/Constants";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { useDispatch } from "react-redux";
import { HANDLE_AUTH } from "store/auth/action.types";
import HomeIcon from "assets/icons/homeIcon";
import PackageIcon from "assets/icons/package";
import Chart from "assets/icons/chart";
import CustomNewIcon from "assets/icons/customIcon";
import DeveloperIcon from "assets/icons/developer";
import { useMemo } from "react";
import { ChartSpline } from "lucide-react";

const Sidebar = () => {
	const { hasCustomAddon,selectedTenant } = useSelector((store: RootState) => store.auth);
		const {selectedStore } = useSelector((store: RootState) => store.customer);

	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const showNoOptions = useMemo(() => [ROUTES.TENANTS].includes(pathname), [pathname]);
	const showFewOptions = useMemo(() => [ROUTES.CUSTOMERS_LIST, ROUTES.DEVELOPERS,ROUTES.USAGE].includes(pathname), [pathname]);
    const showDevOption = useMemo(() => [ROUTES.CUSTOMERS_LIST, ROUTES.DEVELOPERS, ROUTES.USAGE].includes(pathname), [pathname]);
	const showChangeStoreOption = useMemo(() => [ROUTES.CUSTOMERS_LIST].includes(pathname), [pathname]);

	return (
		<>
			<div className={`${styles.sidebar}`}>
				<div>
					<div className={`${styles.sidebar__logo}`}>
						<Link to={ROUTES.HOME}>
							<>
								<span className={`${styles.sidebar__menu}`}>
									<span className={`${styles.sidebar__menuIcon}`}>
										<img className={`${styles.sidebar__logoImg}`} src={logo} alt="swan" title="swan" />
									</span>
									<span className={`${styles.sidebar__menuText}`}>
										<strong>Swan</strong>
									</span>
								</span>
							</>
						</Link>
					</div>
					<ul>
						{hasCustomAddon && (
							<>
								<li>
									<NavLink to={ROUTES.HOME}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<CustomNewIcon />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Custom</span>
												</span>
											</>
										)}
									</NavLink>
								</li>
							</>
						)}
						{!hasCustomAddon && !showNoOptions && !showFewOptions && (
							<>
								<li>
									<NavLink to={ROUTES.HOME}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<HomeIcon />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Home</span>
												</span>
											</>
										)}
									</NavLink>
								</li>
								<li>
									<NavLink to={ROUTES.PRODUCTS}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<PackageIcon />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Products</span>
												</span>
											</>
										)}
									</NavLink>
								</li>
								<li>
									<NavLink to={ROUTES.ANALYTICS}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<Chart />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Analytics</span>
												</span>
											</>
										)}
									</NavLink>
								</li>
							</>
						)}
					</ul>
				</div>
				<ul>
					
					{!showNoOptions && (
						<>
							{ showDevOption && 
							<>
							{/* <li>
								<NavLink to={ROUTES.STYLING}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<DeveloperIcon />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Styling</span>
												</span>
											</>
										)}
									</NavLink>
							</li> */}
							<li>
								<NavLink to={ROUTES.USAGE}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<ChartSpline />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Analytics</span>
												</span>
											</>
										)}
									</NavLink>
							</li>
							<li>
								<NavLink to={ROUTES.DEVELOPERS}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<DeveloperIcon />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Developers</span>
												</span>
											</>
										)}
									</NavLink>
							</li>
							</>
							}
							{(!showChangeStoreOption || selectedStore?.count > 1) &&  (
								<li>
									<NavLink to={ROUTES.CUSTOMERS_LIST}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<CreditCard />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Change Store</span>
												</span>
											</>
										)}
									</NavLink>
								</li>
							)}{" "}
						</>
					)}
					{ showFewOptions && selectedTenant?.count>1 &&  <li>
						<NavLink to={ROUTES.TENANTS}>
										{({ isActive }) => (
											<>
												<span className={`${isActive ? styles.active : ""} ${styles.sidebar__menu}`}>
													<span role="button" className={` ${styles.sidebar__menuIcon}`}>
														<CreditCard />
													</span>
													<span className={`${styles.sidebar__menuText}`}>Tenants</span>
												</span>
											</>
										)}
									</NavLink>
					</li>}
					<li>
						<Link to={ROUTES.CUSTOMERS_LIST}>
							<span className={` ${styles.sidebar__menu}`} onClick={() => dispatch({ type: HANDLE_AUTH })}>
								<span role="button" className={` ${styles.sidebar__menuIcon}`}>
									<LogOut />
								</span>
								<span className={`${styles.sidebar__menuText}`}>Logout</span>
							</span>
						</Link>
					</li>
				</ul>
			</div>
		</>
	);
};
export default Sidebar;
